

import axios from "axios";
import config from "../api-config/config";

const proxyServer = config.serverApiHeavy + "reports2/geofence";

export const GetGeofenceByVehicles = (userToken, vehicleIds, startTime, endTime, geofenceIds) => {
  const criterion = { userToken, vehicleIds, startTime, endTime, geofenceIds };
  return axios
    .post(proxyServer + "/get-by-vehicles", { criterion })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      return err;
    });
};

 